export interface Experience {
  title: string;
  company: string;
  date: string;
  content: string[];
}

export interface Education {
  title: string;
  institution: string;
  date: string;
  content: string[];
}

export const experiences: Experience[] = [
  {
    title: ' Software Engineer',
    company: 'The Lifetime Value Co.',
    date: 'February 2022 - Present',
    content: [
      'Developed and maintained robust Rails applications handling high-volume API requests and data processing. Optimized algorithms and database queries for performance enhancements.',
      'Designed RESTful APIs facilitating seamless frontend-backend integration and enabling third-party data exchange, significantly reducing data retrieval times by 20%. Also Designed and developed high-performance RESTful APIs using Ruby and Ruby on Rails to streamline data exchange and service communication',
      'Engineered and scaled multiple Ruby on Rails microservices for property valuation, integrating services using Docker and Kubernetes for improved deployment workflows and system resilience. Developed Python services that handle complex data interactions and calculations, improving system efficiency and response times.',
      'Developed a Typescript React Web Application that imports components from a shared library of components. It also utilizes multiple microservices for optimal loading, customization and notifications. Worked on multiple projects, mainly on the development of our property product and A/B testing.',
      'Typescript React web application that holds all the shared components. It uses Storybooks to demonstrate and explain how those components are used. Worked on the development of multiple components, utility components, hooks and modals',
    ],
  },
  {
    title: 'Software Developer',
    company: 'Nimble Business Solutions',
    date: 'January 2019 - February 2022',
    content: [
      'Developed Python and Ruby on Rails applications for handling business logic and user data processing. Optimized backend performance and scalability. Enhanced system capabilities to handle API requests efficiently, supporting user authentication and data management.',
      'JavaScript React Web Application that allows our users to login and see the status of their accounts, orders and portfolios. Worked on authentication, authorization, profiles and product view.',
    ],
  },
];

export const education: Education[] = [
  {
    title: 'MS in Data Analytics',
    institution: 'CUNY Baruch College',
    date: '2022 - 2023',
    content: ['GPA: 3.9'],
  },
  {
    title: 'Software Engineering - Full-Stack Web Development',
    institution: 'Flatiron School',
    date: '2020',
    content: [
      'Fast-tracked Software Engineering bootcamp that teaches full-stack web development (Ruby, Javascript, Rails, React and Redux)',
    ],
  },
  {
    title: 'BBA in International Finance',
    institution: 'CUNY Baruch College',
    date: '2014 - 2019',
    content: ['GPA: 3.5'],
  },
  {
    title: 'Exchange Program (6 months)',
    institution: 'Vienna University of Economics and Business',
    date: '2016 - 2017',
    content: ['Grade: 1 (GPA: 4.0)'],
  },
];
